/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useContext } from 'react'
import { FileExcelOutlined, LoadingOutlined, SearchOutlined } from '@ant-design/icons'
import { Form, Button, Row, Table, Pagination, Spin, DatePicker, Col, Select, Input, Radio, Space, Tag } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { SpinIndicator } from 'antd/es/spin'
import { AppContext } from 'layouts/DashboardLayout'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { makeId } from 'utils/helpers'
import {
  SearchConfig,
  ParamsSearchDefault,
  TypeSearch,
  convertQueryStringToObjectBase,
  transformObject,
  JSONToCsv,
  DateFormat,
  convertParamsAxiosBase,
  AxiosResponseList
} from 'pages/base/util'
import { getStaffType, getCity } from './api'
import { getListStaffChange } from 'pages/staff/api'
const { Column, ColumnGroup } = Table
const { RangePicker } = DatePicker
export const antIcon: SpinIndicator = <LoadingOutlined style={{ fontSize: 24 }} spin />

export default function CVStaff() {
  const { notification } = useContext(AppContext)
  const navigate = useNavigate()
  const refCSV = useRef<HTMLAnchorElement>()
  const [form] = Form.useForm()

  const [params, setParams] = useState<ParamsSearchDefault & any>({
    PageSize: 10,
    PageIndex: 1
  })

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [checkCSV, setCheckCSV] = useState<boolean>(false)
  const [dataCSV, setDataCSV] = useState<any>()
  const [mount, setMount] = useState(false)
  const [options, setOptions] = useState({ city: [], staffType: [] })
  const columnSearch: SearchConfig[] = [
    {
      label: 'Thời gian',
      param: 'date',
      type: TypeSearch.day,
      placeholder: 'Trước ngày',
      col: 3
    },
    {
      label: 'Chọn salon',
      param: 'salonId',
      type: TypeSearch.select,
      mode: 'multiple',
      options: options.city,
      placeholder: 'Chọn khu vực',
      fieldNames: { label: 'name', value: 'id' }
    },
    {
      label: 'Bộ phận',
      param: 'staffType',
      type: TypeSearch.select,
      options: options.staffType,
      placeholder: 'Chọn bộ phận',
      fieldNames: { label: 'name', value: 'id' }
    }
  ]
  const handleFetchData = async () => {
    try {
      const [res1, res2, city]: any = await Promise.all([getStaffType(1), getStaffType(2), getCity()])
      if (res1.statusCode === 0 && res2.statusCode === 0 && city.statusCode === 0) {
        setOptions({
          city: [...city.data],
          staffType: [...res1.data, ...res2.data]
        })
      }
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi xảy ra')
    }
  }
  useEffect(() => {
    handleFetchData()
  }, [])

  const handleFetchListStaff = async (paramsSearch: ParamsSearchDefault & any) => {
    try {
      setLoading(true)
      const res: AxiosResponseList & any = await getListStaffChange(paramsSearch)
      setLoading(false)
      if (res.statusCode === 0) {
        setTotal(res.data.totalRecords)
        setData(res.data.listData)
      }
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi! Vui lòng kiểm tra lại')
    }
    setLoading(false)
  }

  const prefetchDataStaffList = () => {
    const check = {}
    const paramsSearchResult = convertQueryStringToObjectBase(window.location.search.replace('?', ''), columnSearch)
    if (Object.keys(paramsSearchResult).length > 0) {
      Object.keys(paramsSearchResult).forEach((i) => {
        if (i.includes('_to') || i.includes('_from')) {
          check[i] = paramsSearchResult[i]
          delete paramsSearchResult[i]
        }
      })
      const result: ParamsSearchDefault & any = { ...transformObject(check), ...paramsSearchResult }
      setParams(result)
      handleFetchListStaff(result)
    } else {
      setData([])
    }
    if (!mount) setMount(true)
  }

  const onExportStaff = async () => {
    try {
      setDataCSV(JSONToCsv(data))
      setCheckCSV(!checkCSV)
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi xảy ra!')
    }
  }

  const onFinish = () => {
    const result: ParamsSearchDefault = {
      PageSize: 0,
      PageIndex: 0
    }
    const value = form.getFieldsValue()
    result.PageSize = params.PageSize
    result.PageIndex = params.PageIndex
    Object.keys(value).map((i) => {
      if (
        typeof value[i] === 'object' &&
        value[i]?.length === 2 &&
        value[i].every((item) => typeof item === 'object')
      ) {
        result[`${i}_from`] = dayjs(value[i][0]).format(DateFormat)
        result[`${i}_to`] = dayjs(value[i][1]).format(DateFormat)
      } else if (typeof value[i] === 'object') {
        result[i] = dayjs(value[i]).format(DateFormat)
      } else result[i] = value[i]
    })
    for (const key in result) {
      if (result[key] === null || result[key] === undefined) {
        delete result[key]
      }
    }
    navigate(`/checkin/cv-staff?${convertParamsAxiosBase({ ...result, PageIndex: 1 })}`)
  }

  const RenderSearchComponent = (type: string, config?: SearchConfig) => {
    const result = {
      DatePicker: (
        <Col span={4}>
          <Form.Item
            name={config.param}
            label={config?.label}
            rules={[{ required: !!config?.require, message: 'Trường bắt buộc phải nhập' }]}
          >
            <RangePicker
              placeholder={['Từ ngày', 'Đến ngày']}
              format={'DD-MM-YYYY'}
              value={
                params[config.param]
                  ? [dayjs(params[config.param][0] || null), dayjs(params[config.param][1] || null)]
                  : undefined
              }
            />
          </Form.Item>
        </Col>
      ),
      Date: (
        <Col span={config?.col || 4}>
          <Form.Item
            name={config.param}
            label={config?.label}
            rules={[{ required: !!config?.require, message: 'Trường bắt buộc phải nhập' }]}
          >
            <DatePicker
              placeholder={config?.placeholder}
              format={'DD-MM-YYYY'}
              className='w-full'
              value={params[config.param] || undefined}
              defaultValue={config?.dateDefault ? dayjs() : null}
              onChange={(e) => {
                setParams({ ...params, [config.param]: e })
                form.setFieldValue(config.param, e)
                form.validateFields([config.param])
              }}
            />
          </Form.Item>
        </Col>
      ),
      Select: (
        <Col span={3}>
          <Form.Item
            name={config.param}
            label={config.label}
            rules={[{ required: !!config?.require, message: 'Trường bắt buộc phải nhập' }]}
          >
            <Select
              allowClear
              // @ts-ignore: Unreachable code error
              mode={config?.mode}
              value={params[config.param]}
              placeholder={config?.placeholder}
              options={config?.options}
              fieldNames={config?.fieldNames}
              showSearch
              optionFilterProp='children'
              filterOption={(input, option) => (option?.name ?? '').toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
      ),
      Input: (
        <Col span={3}>
          <Form.Item
            name={config.param}
            label={config?.label}
            rules={[{ required: !!config?.require, message: 'Trường bắt buộc phải nhập' }]}
          >
            <Input value={params[config.param]} placeholder={config?.placeholder} />
          </Form.Item>
        </Col>
      ),
      Radio: (
        <Col span={3}>
          <Form.Item
            name={config.param}
            label={config?.label}
            rules={[{ required: !!config?.require, message: 'Trường bắt buộc phải nhập' }]}
          >
            <Radio.Group value={params[config.param]}>
              {(config?.options || []).map((i) => (
                <Radio key={makeId()} value={i.value}>
                  {i.label}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>
      )
    }
    return result[type]
  }
  const onReset = (field: string[]) => {
    form.resetFields([...field])
  }
  const onValuesChange = (changedValues) => {
    const keyName = Object.keys(changedValues)[0]
    const value = changedValues[keyName]

    if (keyName.toLowerCase().includes('date')) {
      setParams({
        ...params,
        [keyName]: value ? [dayjs(value[0]).format(DateFormat), dayjs(value[1]).format(DateFormat)] : undefined
      })
    } else {
      setParams({ ...params, ...changedValues })
    }
    // handleChangeValue(changedValues, onReset)
  }
  useEffect(() => {
    prefetchDataStaffList()
  }, [window.location.search])
  useEffect(() => {
    if (dataCSV) {
      refCSV.current.click()
    }
  }, [checkCSV])
  useEffect(() => {
    if (mount) {
      columnSearch.forEach((element) => {
        if (element?.type) {
          if (element?.type === TypeSearch.date) {
            const newParams = params[element.param] ? params[element.param].map((i) => dayjs(i)) : ''
            form.setFieldValue(`${element.param}`, newParams)
          } else if (element?.type === TypeSearch.day) {
            form.setFieldValue(`${element.param}`, dayjs(params[element.param]))
          } else {
            form.setFieldValue(`${element.param}`, params[element.param])
          }
        }
      })
    }
  }, [mount])

  return (
    <div style={{ padding: 20 }} className='w-full search-wrapper'>
      <Form layout='vertical' className='pb-10 pr-5' form={form} onFinish={onFinish} onValuesChange={onValuesChange}>
        <h2 className='mb-7 text-2xl'>{'Hàng tồn kho'}</h2>
        <Row className='items-start flex gap-y-4 xl:w-[90%] 2xl:w-[98%]'>
          {columnSearch.map((item) => {
            return RenderSearchComponent(item.type, item)
          })}
        </Row>
        <div className='bg-white mt-8 2xl:w-[84%] xl:w-[80%]' style={{ padding: '20px 20px 100px 20px' }}>
          <Row className=' flex gap-x-3'>
            <Button
              type='default'
              htmlType='submit'
              className='w-[200px] bg-[#4096ff] text-white hover:bg-white'
              disabled={loading}
            >
              {!loading ? (
                <div className='flex items-center justify-center hover_icon'>
                  <SearchOutlined className='mr-1 text-white' />
                  Xem dữ liệu
                </div>
              ) : (
                <Spin indicator={antIcon} />
              )}
            </Button>
            <Button
              onClick={onExportStaff}
              type='default'
              className='w-[200px] bg-[#28A745] text-white hover:bg-white hover_icon'
            >
              <div className='flex items-center justify-center'>
                <FileExcelOutlined className='mr-1 text-white' />
                Xuất excel
              </div>
            </Button>
            <a
              ref={refCSV}
              style={{ display: 'none' }}
              href={`data:text/csv;charset=utf-8,${encodeURIComponent('\uFEFF' + dataCSV)}`}
              download='danh_sách.csv'
            />

            <Button
              onClick={() => form.resetFields()}
              type='default'
              className='w-[200px] bg-[#4096ff] text-white hover:bg-white'
            >
              Reset Filter
            </Button>
          </Row>

          <Row style={{ display: 'contents' }} gutter={18}>
            <div className='flex items-center justify-between'>
              <h3>
                {'Tổng số : '}
                <span className='text-[red] font-semibold'>{total}</span>
              </h3>
              <Pagination
                className='float-right pb-8 mt-8'
                current={params.PageIndex}
                pageSize={params.PageSize}
                total={total}
                onChange={(page: number, pageSize: number) => {
                  setParams({ ...params, PageSize: pageSize, PageIndex: params.PageSize !== pageSize ? 1 : page })

                  navigate(
                    `/checkin/cv-staff?${convertParamsAxiosBase({
                      ...params,
                      PageSize: pageSize,
                      PageIndex: params.PageSize !== pageSize ? 1 : page
                    })}`
                  )
                }}
                showSizeChanger
              />
            </div>
            <Table dataSource={data} bordered className='overflow-auto'>
              <Column title='STT' dataIndex='index' key='index' />
              <Column title='KHU VỰC' dataIndex='area' key='area' />
              <Column
                title={
                  <div className='flex flex-col items-center text-center gap-y-2 w-[120px]'>
                    TÊN SALON <div className='w-full h-[1px] bg-[#ccc]' /> TỔNG SỐ 3 TỶ LỆ
                  </div>
                }
                dataIndex='salonName'
                key='salonName'
              />
              <Column title='TỔNG SỐ NHÂN VIÊN' dataIndex='mvt' key='staffTotal' />
              <ColumnGroup title='TỶ LỆ THU HỒ SƠ' className='bg-[red]'>
                <Column title='SỐ NHÂN VIÊN ĐỦ 22 NGÀY' dataIndex='export' key='export' />
                <Column title='SỐ NHÂN VIÊN NỘP ĐỦ 3 LOẠI GIẤY TỜ CHÍNH' dataIndex='sell' key='sell' />
                <Column title='TỶ LỆ %' dataIndex='use_sv' key='use_sv' />
              </ColumnGroup>
              <ColumnGroup title='TỶ LỆ THU HỢP ĐỒNG HỌC NGHỀ'>
                <Column title='SỐ NHÂN VIÊN ĐỦ 20 NGÀY' dataIndex='import' key='import' />
                <Column title='SỐ NHÂN VIÊN ĐÃ CÓ HĐHN' dataIndex='ncc_store' key='ncc_store' />
                <Column title='TỶ LỆ %' dataIndex='imp_total_store' key='imp_total_store' />
              </ColumnGroup>
              <ColumnGroup title='TỶ LỆ THU HỢP ĐỒNG LAO ĐỘNG'>
                <Column title='SỐ HĐLĐ PHÁT ĐI' dataIndex='import' key='import' />
                <Column title='SỐ HĐLĐ THU VỀ' dataIndex='ncc_store' key='ncc_store' />
                <Column title='TỶ LỆ %' dataIndex='imp_total_store' key='imp_total_store' />
              </ColumnGroup>
            </Table>
            <Pagination
              className='float-right pb-8 mt-8'
              current={params.PageIndex}
              pageSize={params.PageSize}
              total={total}
              onChange={(page: number, pageSize: number) => {
                setParams({ ...params, PageSize: pageSize, PageIndex: params.PageSize !== pageSize ? 1 : page })
                navigate(
                  `/checkin/cv-staff?${convertParamsAxiosBase({
                    ...params,
                    PageSize: pageSize,
                    PageIndex: params.PageSize !== pageSize ? 1 : page
                  })}`
                )
                setTimeout(
                  () =>
                    window.document.getElementById('body__page').scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    }),
                  500
                )
              }}
              showSizeChanger
            />
          </Row>
        </div>
      </Form>
    </div>
  )
}
